import { useTranslation } from 'react-i18next';

import { TUseDownloadSewExportsProps } from '@/backoffice/features/data-exports/hooks/use-download-sew-exports/use-download-sew-exports.types';
import { useDownloadFile } from '@/shared/hooks/use-download-file/use-download-file';
import {
  showToastError,
  showToastSuccess,
  showToastWarning,
} from '@/shared/utils/toast';

export const useDownloadSewExports = () => {
  const { t } = useTranslation();
  const { downloadContent, downloadUrl } = useDownloadFile();

  return ({
    exportUrl,
    logFile,
    baseFileName,
    hasErrors,
  }: TUseDownloadSewExportsProps) => {
    const isLogFileOnly = !!logFile && !exportUrl;

    if (exportUrl) {
      downloadUrl(exportUrl);
    }
    if (logFile) {
      downloadContent(logFile, `${baseFileName}.log`);
    }

    if (hasErrors && isLogFileOnly) {
      showToastError(t('backoffice:sew.data_exports.download_error'), {
        autoClose: false,
      });
    } else if (hasErrors) {
      showToastWarning(t('backoffice:sew.data_exports.download_warning'), {
        autoClose: false,
      });
    } else {
      showToastSuccess(t('common:download_success'));
    }
  };
};
